<template>
  <PlaceholderComponent
    v-if="shouldDisplayPlaceholderComponent(isEditMode, mode, visible)"
    :name="tracking_id"
    v-bind="$attrs"
  />
  <template v-else>
    <EditableComponent
      v-if="isEditMode && !isViewOnlyMode && componentPermissions.hasSomethingEditable"
      :id="id"
      :active="componentEditMode && componentEditMode?.id === id"
      :duplicate="componentPermissions.canDuplicate"
      :remove="componentPermissions.canRemove"
      :selected="componentSelectedMode && componentSelectedMode?.id === id"
      :settings="!usedInSectionId"
      :stylable="!usedInSectionId"
      @duplicate="duplicate(id)"
      @remove="removeComponentById(id)"
      @select="setComponentSelectedMode(id)"
      @settings="setComponentSettingsMode(id)"
      @style="emit('style', $event)"
    >
      <TimelineRaw :id="id" :data="data" :used-in-section-id="usedInSectionId" v-bind="$attrs" />
    </EditableComponent>
    <TimelineRaw v-else :id="id" :data="data" :used-in-section-id="usedInSectionId" v-bind="$attrs" />
  </template>
</template>

<script lang="ts" setup>
import { toRefs, onMounted, type CSSProperties } from 'vue'

import EditableComponent from '@canvas-builder/components/container/EditableComponent/EditableComponent.vue'
import type { TimelineProps, ComponentNode } from '@canvas-builder/types/canvas'
// import { ComponentTypes } from '@canvas-builder/types/canvas'
import useCanvas from '@canvas-builder/composables/useCanvas'
import TimelineRaw from './Timeline.raw.vue'
import { defaultWhenUsedInSection } from '@canvas-builder/constants'
import type { CanvasRetrieve } from '@openapi'
import useComponentPermissions from '@canvas-builder/composables/useComponentPermissions'
import { shouldDisplayPlaceholderComponent } from '@canvas-builder/util/canvas.util'
import PlaceholderComponent from '@canvas-builder/components/container/PlaceholderComponent/PlaceholderComponent.vue'

defineOptions({
  inheritAttrs: false,
})

const props = withDefaults(
  defineProps<{
    id: string
    data: TimelineProps
    when_used_in_section?: ComponentNode['when_used_in_section']
    usedInSectionId?: CanvasRetrieve['id']
    visible?: ComponentNode['visible']
    tracking_id?: string
  }>(),
  {
    when_used_in_section: () => defaultWhenUsedInSection,
    usedInSectionId: '',
  },
)

const emit = defineEmits<{
  style: [s: CSSProperties]
}>()

const { id, usedInSectionId, when_used_in_section } = toRefs(props)
const componentPermissions = useComponentPermissions({
  id,
  usedInSectionId,
  when_used_in_section,
})

const {
  mode,
  isEditMode,
  componentEditMode,
  componentSelectedMode,
  justAddedComponentId,
  isViewOnlyMode,
  removeComponentById,
  // setComponentEditMode,
  setComponentSelectedMode,
  duplicate,
  setComponentSettingsMode,
} = useCanvas()

onMounted(() => {
  if (justAddedComponentId.value === props.id) {
    justAddedComponentId.value = null

    // if (!props.data?.events?.length) setComponentEditMode(ComponentTypes.Timeline, props.id)
  }
})
</script>
